(() => {
  if (window.__dillJohanPhysicalHeroInteraction) return;
  window.__dillJohanPhysicalHeroInteraction = true;

  const linkSelector = '.hero__artwork-link';

  function reset(canvas) {
    if (!canvas) return;
    canvas.classList.remove('is-activating');
    const link = canvas.querySelector(linkSelector);
    if (link) link.removeAttribute('aria-busy');
    window.clearTimeout(canvas.__dillJohanActivationTimer);
  }

  function activate(link) {
    const canvas = link.closest('.hero__artwork-canvas');
    if (!canvas) return;
    canvas.classList.add('is-activating');
    link.setAttribute('aria-busy', 'true');
    window.clearTimeout(canvas.__dillJohanActivationTimer);
    canvas.__dillJohanActivationTimer = window.setTimeout(() => reset(canvas), 5000);
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest(linkSelector);
    if (!link || event.defaultPrevented) return;

    activate(link);

    const opensElsewhere =
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === '_blank' ||
      link.hasAttribute('download');

    if (opensElsewhere) return;

    event.preventDefault();
    window.setTimeout(() => window.location.assign(link.href), 80);
  }, true);

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.hero__artwork-canvas.is-activating').forEach(reset);
  });
})();
